import { FOLDER_NAMES } from "../constants/templateConstants";

// The backend stores the "Main Templates" folder as "Drafts"; the UI shows "Main Templates".
const normalize = (name?: string): string => name?.trim().toLowerCase() ?? "";

export const isDraftsFolderName = (name?: string): boolean =>
  normalize(name) === FOLDER_NAMES.DRAFTS.toLowerCase();

export const isMainTemplatesFolderName = (name?: string): boolean =>
  normalize(name) === FOLDER_NAMES.MAIN_TEMPLATES.toLowerCase();

/** True for any name that refers to the Main Templates folder (UI or backend naming). */
export const isMainTemplatesAlias = (name?: string): boolean =>
  isDraftsFolderName(name) || isMainTemplatesFolderName(name);

/** Backend folder name -> UI label. */
export const toDisplayFolderName = (name: string): string =>
  isDraftsFolderName(name) ? FOLDER_NAMES.MAIN_TEMPLATES : name;

/** UI folder name -> value sent to the backend. */
export const toApiFolderName = (name: string): string =>
  isMainTemplatesFolderName(name) ? FOLDER_NAMES.DRAFTS : name;

/** Default folder for Clone/Rename: the template's own folder, with Drafts shown as Main Templates. */
export const getDefaultFolderForTemplate = (folderName?: string): string => {
  const name = folderName?.trim() ?? "";
  return !name || isMainTemplatesAlias(name) ? FOLDER_NAMES.MAIN_TEMPLATES : name;
};
